import { render, staticRenderFns } from "./beta-feature-control.vue?vue&type=template&id=66db5464&"
import script from "./beta-feature-control.vue?vue&type=script&lang=ts&"
export * from "./beta-feature-control.vue?vue&type=script&lang=ts&"
import style0 from "./beta-feature-control.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports